module.exports = __webpack_public_path__ + "static/media/fire.8efd23a4.png";